var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5839 37.4071C42.858 39.0841 41.9988 40.6278 41.0033 42.047C39.6463 43.9817 38.5352 45.321 37.6789 46.0647C36.3516 47.2854 34.9294 47.9105 33.4065 47.9461C32.3132 47.9461 30.9947 47.635 29.4599 47.0039C27.9201 46.3758 26.5051 46.0647 25.2112 46.0647C23.8542 46.0647 22.3988 46.3758 20.8421 47.0039C19.2831 47.635 18.0271 47.9639 17.0668 47.9964C15.6064 48.0587 14.1508 47.4157 12.6978 46.0647C11.7704 45.2558 10.6105 43.8692 9.22087 41.9048C7.72995 39.8071 6.50422 37.3745 5.54395 34.6013C4.51554 31.6058 4 28.7052 4 25.897C4 22.6802 4.69509 19.9057 6.08734 17.5808C7.18153 15.7133 8.63718 14.2401 10.4591 13.1587C12.2809 12.0772 14.2495 11.5261 16.3694 11.4909C17.5293 11.4909 19.0505 11.8497 20.9408 12.5548C22.8258 13.2624 24.0361 13.6212 24.5667 13.6212C24.9635 13.6212 26.308 13.2016 28.5874 12.3652C30.7428 11.5895 32.562 11.2684 34.0524 11.3949C38.0908 11.7208 41.1247 13.3127 43.1425 16.1808C39.5307 18.3692 37.7441 21.4343 37.7797 25.3663C37.8123 28.429 38.9233 30.9777 41.107 33.0013C42.0966 33.9406 43.2017 34.6665 44.4313 35.182C44.1646 35.9553 43.8832 36.696 43.5839 37.4071ZM34.322 0.960823C34.322 3.36137 33.445 5.60276 31.6969 7.67736C29.5873 10.1437 27.0357 11.5688 24.2687 11.3439C24.2334 11.0559 24.213 10.7528 24.213 10.4343C24.213 8.12979 25.2162 5.6635 26.9978 3.64696C27.8872 2.62596 29.0185 1.77701 30.3903 1.09978C31.7591 0.43266 33.0539 0.0637274 34.2716 0.000549316C34.3072 0.321465 34.322 0.642401 34.322 0.960792V0.960823Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_88"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/Apple.cebf296e394040468274101024ef935f.svg";
export { ForwardRef as ReactComponent };